import React, {useEffect} from 'react';
// import styles from '../homepage.module.css'
import styles from './whoWeAre.module.css'
import {useTranslation} from "react-i18next";
import LazyText from "../../common/imagescroll/LazyText";
// import Lazy from "../../../common/lazy-scroll/Lazy";
// import {HOME_PAGE_CONTENT} from "../homePageContent";

const WhoWeAre: React.FC = () => {

    const { t, i18n } = useTranslation(); // Use the translation hook

    const pageTitle = "Custom Web Development, Software & Design Solutions in Kanata - XSCI";
    const metaDescriptionContent = "XSCI specializes in custom web development, responsive design, and software solutions in Kanata. " +
        "We help businesses grow with scalable, high-performing web apps and modern digital solutions. Get started with a custom project today!";
    // Set the meta description
    let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

    // The content you're trying to use for the meta description
    const descriptionContent = metaDescriptionContent;

    useEffect(() => {
        document.title = pageTitle;

        // Set the meta description
        let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

        // The content you're trying to use for the meta description
        const descriptionContent = metaDescriptionContent;

        if (metaDescription) {
            metaDescription.setAttribute("content", descriptionContent); // Correctly set the content
        } else {
            metaDescription = document.createElement("meta") as HTMLMetaElement;
            metaDescription.name = "description";
            metaDescription.content = descriptionContent;
            document.head.appendChild(metaDescription);
        }
    }, []);


    return (
        <section className={styles.section_container}>
            <h2 className={"sectionTitle"} style={{textAlign: "center"}}>What Does XSCI Do?</h2>
            <div className={styles.content_wrapper}>
                XSCI focuses on designing and building systems, not just individual deliverables.
                We design and develop robust websites and web applications that support day-to-day operations,
                connect processes, and improve how businesses work. Every solution is engineered with structure, clarity,
                and scalability in mind, ensuring technology supports efficient workflows and long-term growth across industries.
            </div>
        </section>
    );
};

export default WhoWeAre;
